import { MutationTree } from 'vuex';
import { State } from './configure.store';
import * as types from '../../apm/mutation-types';
import { KeyLabel } from './config';
import { Service } from '@/utils/types/global';
import { initialState } from '@/store/modules/alertV2/configure/configure.store';

const mutations: MutationTree<State> = {

  setShowAddConfigureAlert(state: State, data: boolean) {
    state.showAddConfigureAlert = data;
  },
  setShowEditConfigureAlert(state: State, data: boolean) {
    state.showEditConfigureAlert = data;
  },
  setCurrentEditConfigureAlert(state: State, data: {}) {
    state.currentEditConfigureAlert = data;
  },
  setShowTotalNotificationChannelsTagged(state: State, data: boolean) {
    state.showTotalNotificationChannelsTagged = data;
  },
  setTotalNotificationChannelIdsTagged(state: State, data: {}[]) {
    state.totalNotificationChannelIdsTagged = data;
  },
  setNotificationsChannels(state: State, data: {}[]) {
    state.notificationsChannels = data;
  },
  setMetricsMap(state: State, data: {}[]) {
    state.metricsMap = data;
  },
  setAggregationMap(state: State, data: {}[]) {
    state.agregationMap = data;
  },
  setAlertCapabilities(state: State, data: KeyLabel[]) {
    state.alertCapabilities = data;
  },
  setCurrentAlertCapability(state: State, data: KeyLabel) {
    state.currentCapability = data;
  },
  setCurrentAlertApplication(state: State, data: Service) {
    state.currentApplication = data;
  },
  setCurrentSubType(state: State, data: String) {
    state.currentSubType = data;
  },
  setEndpoints(state: State, data: KeyLabel[]) {
    state.endpoints = data;
  },
  setInstances(state: State, data: KeyLabel[]) {
    state.instances = data;
  },
  setAlertApplication(state: State, data: Service[]) {
    state.alertApplication = data;
  },
  setCreateAlertPopupActive(state: State, data: boolean) {
    state.isCreateAlertPopupActive = data;
  },
  setRules(state: State, data: {}[]) {
    state.rules = data;
  },
  setTotalRules(state: State, data: number) {
    state.totalRules = data;
  },
  setSearchTotalRules(state: State, data: number) {
    state.searchTotalRules = data;
  },
  reloadConfiguredAlerts(state: State, data: boolean) {
    state.refreshAlertRules = data;
  },
  setIsSearchedAlarmQuery(state: State, data: boolean) {
    state.isSearchedAlarmQuery = data;
  },
  setIsErrorCodeEnabled(state: State, data: boolean) {
    state.isErrorCodeEnabled = data;
  },
  setIsStatusTypeEnabled(state: State, data: boolean) {
    state.isStatusTypeEnabled = data;
    state.isErrorCodeEnabled = data
  },
  setAlertApplicationCount(state: State, data: Number) {
    state.alertApplicationCount = data;
  },
  setEndpointCount(state: State, data: Number) {
    state.endpointCount = data;
  },
  setInstanceCount(state: State, data: Number) {
    state.instanceCount = data;
  },
  setServiceCurrentPage(state: State, data: Number) {
    state.serviceCurrentPage = data;
  },
  setAlertApplicationsWithWritePermission(state: State, data: Service[]) {
    state.alertApplicationsWithWritePermission = data;
  },
  setAlertApplicationsWithWritePermissionCount(state: State, data: Number) {
    state.alertApplicationsWithWritePermissionCount = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
